import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes, { any } from 'prop-types'
import dayjs from 'dayjs'
import { Grid } from '../../../../../components/mui/Core/index'
import TwoLineButton from '../../../../../components/genericcomponents/twolinebutton/TwoLineButton'
import SubHeader from '../../../../../components/SubHeader/sub-header'
import Constants from '../../../../../constants/en.json'
import { inputFormattingConstants } from '../../../../../constants/input-formatting-constants'

function ReportsByCategory({ reports, category, title, searchvalue, handleSearchResult }) {
  const navigate = useNavigate()
  const [doesExist, setDoesExist] = useState(false)
  const [results, setResults] = useState([])
  const dateTimeFormat = inputFormattingConstants.dateFormats.MMDDYYYYHHmmA
  const REPORTS_REPLACE_STRING = 'Reports'

  useEffect(() => {
    setDoesExist(false)
    if (reports) {
      const searchResult = reports.filter((data) =>
        data.reportTypeReadable.toLowerCase().includes(searchvalue.toLowerCase()),
      )
      searchResult.map((data) => data.reportCategory === category && setDoesExist(true))
      setResults(searchResult)
    }
  }, [searchvalue, category, reports])

  const handleNavigateToReportCategoryPage = (data) => {
    navigate(`/displayreports/${data.reportType.toLowerCase()}`, {
      state: {
        reportTitle: data.reportTypeReadable,
        orderBy: data.reportType,
        category: data.reportCategory,
        cognosReportingUrl: data.cognosReportURL,
      },
    })
  }

  const subHeaderContainerStyle = { mt: 4 }

  if (results.length < 1) {
    handleSearchResult(true)
  } else {
    handleSearchResult(false)
  }

  if (doesExist) {
    return (
      <Grid container size={{ xs: 12 }} spacing={4}>
        <Grid size={{ xs: 12 }} sx={subHeaderContainerStyle}>
          {/* TODO: When time permits, see if we can have backend
              return title without "Reports"  */}
          <SubHeader title={title.replace(REPORTS_REPLACE_STRING, '')} />
        </Grid>
        <Grid container>
          {results.map((data) => {
            const reportType = data?.reportType
            const reportCategoryTitle = data?.reportTypeReadable.replace(REPORTS_REPLACE_STRING, '')
            const lastGeneratedDateTime = data?.lastGeneratedDateTime
              ? `${Constants.reports.LAST_GENERATED} ${dayjs(data.lastGeneratedDateTime).format(dateTimeFormat)}`
              : null
            return (
              data.reportCategory === category && (
                <TwoLineButton
                  key={reportType}
                  lineOne={reportCategoryTitle}
                  lineTwo={lastGeneratedDateTime}
                  handleButtonAction={() => {
                    handleNavigateToReportCategoryPage(data)
                  }}
                />
              )
            )
          })}
        </Grid>
      </Grid>
    )
  }
}

ReportsByCategory.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.objectOf(any)).isRequired,
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  searchvalue: PropTypes.string,
  handleSearchResult: PropTypes.func.isRequired,
}

export default ReportsByCategory
